import { useToast } from '@ais-ui/ui-core';
import React, { useState } from 'react';

import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useSendMessage } from '@ais-ui/api';
import { mutateCallbacks } from '../../utils/mutateCallbacks';
import { useLocalization } from '@ais-ui/locale-management';
import {
  convertSendMessageValuesToBackend,
  sendMessageFormSchema,
  SendMessageFormValues,
} from './sendMessageForm';
import { SendMessageDialog } from './SendMessageDialog';
import type { Ship } from '@ais-ui/utils';

interface SendMessageProps {
  setShowDialog: (showDialog: boolean) => void;
  defaultReceiver?: Ship | null;
}

export const SendMessage = ({
  setShowDialog,
  defaultReceiver = null,
}: SendMessageProps) => {
  const { messages } = useLocalization();
  const { mutate } = useSendMessage();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { toast } = useToast();

  const form = useForm<SendMessageFormValues>({
    resolver: zodResolver(sendMessageFormSchema),
    defaultValues: {
      type: 'addressed',
      sender: undefined,
      receiver: defaultReceiver,
      message: '',
      pss: undefined,
    },
  });

  const onSendMessage = async (data: SendMessageFormValues) => {
    const backendValues = convertSendMessageValuesToBackend(data);

    setIsSubmitting(true);

    const callBacks = mutateCallbacks(
      toast,
      messages,
      'send',
      'message',
      setIsSubmitting,
      setShowDialog,
    );

    mutate({ messageSendPostRequest: backendValues }, callBacks);
  };

  return (
    <SendMessageDialog
      form={form}
      onSubmit={onSendMessage}
      isSubmitting={isSubmitting}
      setShowOuterDialog={setShowDialog}
    ></SendMessageDialog>
  );
};
